export default function FooterBar() {
  return (
    <div>
      <hr></hr>
      <br></br>
      <br></br>
      <footer className="mb-6 px-6 md:px-0">
        <div className="grid gap-5 grid-cols-5 container mx-auto space-x-6">
          <div>
            <h1 className="text-2xl font-bold text-rose-400">WHY FLORIST</h1>
            <p>The largest online florist to buy flowers in Indonesia.</p>
            <spa>© Ratih 2022.</spa>
          </div>
          <div className="pt-2">
            <ul>
              <li>Add your flowers</li>
              <li>About us</li>
              <li>F.A.Q</li>
              <li>Help</li>
              <li>Contact</li>
            </ul>
          </div>
          <div className="pt-2">
            <ul>
              <li>Purworejo</li>
              <li>Indramayu</li>
              <li>Krapyak</li>
              <li>Rejang Lobong</li>
              <li>Nagekeo</li>
            </ul>
          </div>
          <div className="pt-2">
            <ul>
              <li>Morotai</li>
              <li>Bitung</li>
              <li>Jember</li>
              <li>Gresik</li>
              <li>Bantul</li>
            </ul>
          </div>
          <div className="pt-2">
            <div>
              <div className="flex space-x-4 text-gray-500 text-center">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                    />
                  </svg>
                </span>
              </div>
              <div className="flex mt-12">
                <p>Privacy & Cookies</p>
                <p>Terms of use</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
